import React from 'react';
import styled, {css} from "styled-components"
import mainbg from "../assets/mainbg.png"
import logobg from "../assets/logoheadign.png"
import hand from "../assets/hand.png"
import experience from "../assets/experience.svg"
import diagram from "../assets/diagram.svg"
import shield from "../assets/shield.svg"
import wave from "../assets/wave.png"
import pinkStain from "../assets/pinkstain.png"
import blueStain from "../assets/bluestain.png"
import leftFlower from "../assets/leftflower.png"
import rightFlower from "../assets/right flower.png"
import stats from "../assets/stats.png"
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
AOS.init();

const Wrapper = styled.div`
position:relative;
overflow: hidden;
`
const HeadingWrapper = styled.div`
  background: url(${mainbg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
      width:300px;
      height: 300px;
      
  @media (min-width: 840px) {
       width: initial;
       height: initial;
    }
  }
`


const Jumbotron = styled.div` 
    width:90%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    margin:0 auto;
    margin-top: 4rem;
    padding:0rem 1rem;
    position: relative;
    overflow: hidden;
    
@media (min-width: 660px) {
        padding:0rem 1rem;
        margin:0rem auto;

    }

@media (min-width: 940px) {
        justify-content: space-between;
        flex-direction: row;  
        margin-top: 8rem;
    }

@media (min-width: 1500px) {
        width:80%;
    }






`
const JumboTextContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color:#8F2699;
    
    @media (min-width: 600px) {
        margin-right: 2rem;
        padding: 0 5rem;

    }
@media (min-width: 940px) {
        margin-right: 2rem;
    }
`


const JumbImg = styled.img`
        width:270px;

    @media (min-width: 660px) {
            width:350px;
        }

    @media (min-width: 1300px) {
            width:600px;

        }
`

const JumbText = styled.p`
    font-size: 1.7rem;
    width:100%;
@media (min-width: 660px) {
        font-size: 2rem;
        max-width: 800px;
    }



@media (min-width: 1300px) {
        font-size: 3rem;
    }
`

const AdvTitle = styled.div`
    font-size:3rem;
    color:#fff;
    text-align: center;
    margin: 3rem;
    font-weight: 700;
    
      @media (min-width: 770px) {
          font-size: 4rem;
        }
     @media (min-width: 1400px) {
         font-size: 6rem;
        }
    
        ${({secondary}) =>
    secondary && css`
      margin:10rem 0;
      color:#964B9D;
    `
}
`

const AdvantagesWrapper = styled.div`
    background:#964B9D ;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    min-height: 400px;
`

const Wave = styled.img`
width:104%;
position:relative;

  @media (min-width: 1010px) {
        left:-30px;

        }
`

const AdvantagesContainer = styled.div`
    width:95%;
    margin:3rem auto 10rem auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    position:relative;
    top: 40px;

@media (min-width: 570px) {
        justify-content: space-between;
        flex-direction: row;
    }


@media (min-width: 930px) {
        width:80%;

    }

@media (min-width: 1200px) {
        width:70%;

    }
`

const AdvItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    font-size: 2rem;
    color:#fff;
    margin: 3rem 0;

   @media (min-width: 400px) {
        width: 350px;
    }

  @media (min-width: 770px) {
        font-size: 2.5rem;
        margin:0;
    }
    
    
     
          @media (min-width: 1400px) {
                 font-size: 3rem;
        }

    img {
        margin-bottom: 2rem;
        width: 70px;
        height: 70px;


    @media (min-width: 1000px) {
            width: 90px;
            height: 90px;
        }
        
          @media (min-width: 1400px) {
            width: 120px;
            height: 120px;
        }
    }
`

const RoadMapWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
width:100%;
position:relative;
margin:8rem  0;


  @media (min-width: 1000px) {
         margin:8rem 0 22rem 0;
        }
`
const RoadMapStep = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
position:relative;
max-width: 300px;
margin:7rem 0;

 @media (min-width: 500px) {
      padding-left: 9rem;
      align-items: flex-start;
      margin:4rem 0;
    }

@media (min-width: 440px) {
     max-width: 400px;
    }

@media (min-width: 840px) {
     max-width: 600px;
    }


    ${({secondary}) =>
    secondary && css`
    align-items: center;
    


 @media (min-width: 500px) {
     padding-left: 0rem;
     padding-right: 9rem;
     align-items: flex-end;

    }
    `
}


`

const StepTitle = styled.h4`
color:#BD6AA9;
font-weight: 700;
font-size: 2rem;
margin:0;

 @media (min-width: 840px) {
      font-size: 3rem;
      margin:1rem 0;
    }
    ${({secondary}) =>
    secondary && css`
    color:#398EB8;
    `
}
`

const StepDesc = styled.p`
color:#BD6AA9;
font-size: 1.6rem;
margin:1rem 0;
text-align: center;
 @media (min-width: 500px) {
    text-align: left;
    }

 @media (min-width: 840px) {
      font-size: 1.8rem;

    }

    ${({secondary}) =>
    secondary && css`
    color:#398EB8;
    text-align: center;
    
    
 @media (min-width: 500px) {
    text-align: right;
    }
    `
}
`

const StepImg = styled.div`
  position:absolute;
  left:50%;
  top:-80px;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateX(-50%);
  
   @media (min-width: 500px) {
        left:30px;
        top:0px;
    }

  @media (min-width: 840px) {
         left:0;
         top:10px;
    }
  
  p {
  font-size: 7rem;
  font-weight: 700;
  color:#fff;
  position:relative;
  z-index: 9999;
  margin:0;
  
  @media (min-width: 840px) {
      font-size: 10rem;
    }
  }
  
  img {
  height: 110px;
  width:150px;
  position:absolute;
  z-index: -1;
  
  
    @media (min-width: 840px) {
      width:200px;
      height: 150px;
    }
  }
  
  
      ${({secondary}) =>
    secondary && css`
      right:50%;
      transform: translateX(50%);
      left: initial;
      top:-80px;
      
        @media (min-width: 500px) {
            transform:none;
            right:30px;
            left: initial;
            top:0px;
          }
      
      
        @media (min-width: 840px) {
          right:0;
          left: initial;
          top:10px;
    }
    `
}
`

const LeftFlower = styled.img`
position:absolute;
left:0;
top:50px;
width:200px;
display: none;

@media (min-width: 1200px) {
        display: block;
`

const RightFlower = styled.img`
position:absolute;
right:0;
bottom:-50px;
width:200px;
display: none;

@media (min-width: 1200px) {
        display: block;
}
`

const FaqWrapper = styled.div`
width:80%;
display: flex;
justify-content: center;
align-items: flex-start;
flex-wrap: wrap;
margin:5rem auto;
`

const FaqItem = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin:0 5rem;
`

const Question = styled.p`
color:#933B9B;
font-weight: 700;
font-size: 2.5rem;
`

const AnswerBox = styled.p`
width:300px;
border-radius: 15px;
box-shadow: 0 0 20px -8px #964B9D;
color:#8F2699;
padding:3rem 4rem;
font-size: 1.8rem;


@media (min-width: 450px) {
       width:400px;
       font-size: 2rem;

}

      ${({secondary}) =>
        secondary && css`
        background: #964B9D;
        color:#fff;
        `
}
`
const Home = () => {


    return (
        <Wrapper>
            <HeadingWrapper>
                <img src={logobg} alt="logo" data-aos="fade-up"/>
            </HeadingWrapper>
            <Jumbotron>
                <JumboTextContent >
                    <JumbText data-aos="fade-up-right">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rhoncus aliquam mattis.
                        Aliquam arcu
                        ipsum, semper at facilisis eu, gravida laoreet sapien. Pellentesque luctus lectus et dui
                        scelerisque,
                        nec rhoncus erat tincidunt. Aenean viverra eleifend nisi, ac sodales purus consectetur
                        malesuada.
                        Curabitur nibh magna,nec rhoncus erat tincidunt. Aenean viverra eleifend nisi, ac sodales
                        purus
                        consectetur malesuada.
                        Curabitur nibh magna,
                    </JumbText>
                </JumboTextContent>
                <JumbImg src={hand} alt="hand" data-aos="fade-up-left"/>

            </Jumbotron>


            <AdvantagesWrapper>
                <AdvTitle data-aos="fade-down">
                    Why Ambient Finance?
                </AdvTitle>
                <AdvantagesContainer>
                    <AdvItem data-aos="fade-up">
                        <img src={diagram} alt="diagram"/>
                        DualBase Redesinged
                    </AdvItem>

                    <AdvItem data-aos="fade-up" data-aos-delay="100">
                        <img src={shield} alt="shield"/>
                        Passive Yield Farming
                    </AdvItem>

                    <AdvItem data-aos="fade-up" data-aos-delay="200">
                        <img src={experience} alt="experience"/>
                        Fair Launch
                    </AdvItem>
                </AdvantagesContainer>
            </AdvantagesWrapper>
            <Wave src={wave} alt="wave"/>

            <RoadMapWrapper>

                <RoadMapStep data-aos="fade-right">
                    <StepImg>
                        <img src={pinkStain} alt="stain"/>
                        <p>1</p>
                    </StepImg>
                    <StepTitle>
                        Lorem ipsum
                    </StepTitle>
                    <StepDesc>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor
                    </StepDesc>
                </RoadMapStep>

                <RoadMapStep secondary data-aos-delay="100" data-aos="fade-left">
                    <StepImg secondary>
                        <img src={blueStain} alt="stain"/>
                        <p>2</p>
                    </StepImg>
                    <StepTitle secondary>
                        Lorem ipsum
                    </StepTitle>
                    <StepDesc secondary>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor
                    </StepDesc>
                </RoadMapStep>


                <RoadMapStep data-aos-delay="200" data-aos="fade-right">
                    <StepImg>
                        <img src={pinkStain} alt="stain"/>
                        <p>3</p>
                    </StepImg>
                    <StepTitle>
                        Lorem ipsum
                    </StepTitle>
                    <StepDesc>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor
                    </StepDesc>
                </RoadMapStep>


                <RoadMapStep secondary data-aos-delay="300" data-aos="fade-left">
                    <StepImg secondary>
                        <img src={blueStain} alt=""/>
                        <p>4</p>
                    </StepImg>
                    <StepTitle secondary>
                        Lorem ipsum
                    </StepTitle>
                    <StepDesc secondary>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse auctor est in tempor
                    </StepDesc>
                </RoadMapStep>
                <LeftFlower src={leftFlower} alt="flower"/>
                <RightFlower src={rightFlower} alt="flower"/>


            </RoadMapWrapper>

            <Jumbotron>
                <JumbImg src={stats} alt="stats" data-aos="fade-right"/>

                <JumboTextContent>
                    <JumbText data-aos="fade-left">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rhoncus aliquam mattis.
                        Aliquam arcu
                        ipsum, semper at facilisis eu, gravida laoreet sapien. Pellentesque luctus lectus et dui
                        scelerisque,
                        nec rhoncus erat tincidunt. Aenean viverra eleifend nisi, ac sodales purus consectetur
                        malesuada.
                        Curabitur nibh magna,nec rhoncus erat tincidunt. Aenean viverra eleifend nisi, ac sodales
                        purus
                        consectetur malesuada.
                        Curabitur nibh magna,
                    </JumbText>
                </JumboTextContent>
            </Jumbotron>
            <AdvTitle secondary data-aos="fade-down">
                Frequently Asked Questions
            </AdvTitle>
            <FaqWrapper>
                <FaqItem data-aos="fade-up">
                    <Question>What is Ambient?</Question>
                    <AnswerBox>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur. Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                    </AnswerBox>
                </FaqItem>


                <FaqItem data-aos="fade-up" data-aos-delay="100">
                    <Question>What is Ambient?</Question>
                    <AnswerBox secondary>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur.
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                    </AnswerBox>
                </FaqItem>


                <FaqItem data-aos="fade-up" data-aos-delay="200">
                    <Question>What is Ambient?</Question>
                    <AnswerBox>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur. Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                    </AnswerBox>
                </FaqItem>


                <FaqItem data-aos="fade-up" data-aos-delay="300">
                    <Question>What is Ambient?</Question>
                    <AnswerBox>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur.
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                    </AnswerBox>
                </FaqItem>


                <FaqItem data-aos="fade-up" data-aos-delay="400">
                    <Question>What is Ambient?</Question>
                    <AnswerBox>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur. Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur. Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur. Morbi
                        suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur.
                    </AnswerBox>
                </FaqItem>


                <FaqItem data-aos="fade-up" data-aos-delay="500">
                    <Question>What is Ambient?</Question>
                    <AnswerBox>
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        amet. Morbi ac posuere ipsum. Vestibulum pharetra metus eget nulla accumsan consectetur.
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                        Morbi suscipit eu urna non placerat. Fusce sagittis laoreet est, ut euismod elit dapibus sit
                    </AnswerBox>
                </FaqItem>
            </FaqWrapper>
        </Wrapper>
    );
};

export default Home;